import { EMAIL, MORE_PHONES, PHONE } from "../content/site";

const LINK = "text-teal-deep underline underline-offset-4";

/** "Questions? Call or WhatsApp ..., or email ..." as one quiet line. */
export function ContactLine({ className = "" }: { className?: string }) {
  const [second, third] = MORE_PHONES;
  return (
    <p className={`text-sm leading-relaxed text-ink-soft ${className}`}>
      Questions? Call or WhatsApp{" "}
      <a href={PHONE.tel} className={LINK}>
        {PHONE.display}
      </a>
      ,{" "}
      <a href={second.tel} className={LINK}>
        {second.display}
      </a>{" "}
      or{" "}
      <a href={third.tel} className={LINK}>
        {third.display}
      </a>
      , or email{" "}
      <a href={`mailto:${EMAIL}`} className={LINK}>
        {EMAIL}
      </a>
      .
    </p>
  );
}
